import { render, staticRenderFns } from "./conta-corrente.vue?vue&type=template&id=f0e85634"
import script from "./conta-corrente.vue?vue&type=script&lang=js"
export * from "./conta-corrente.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports